export default function Marquee() {
  const words = ["Bienvenue chez KARYNA", "Bien-être", "Mouvement", "Style", "Voyage", "Décoration"];
  const Row = () => (
    <span className="flex items-center">
      {Array(4).fill(words).flat().map((w, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className={`font-accent italic text-2xl md:text-3xl ${w.startsWith("Bienvenue") ? "text-gold" : "text-choco/90"}`}>{w}</span>
          <span className="text-gold text-xl md:text-2xl mx-5 not-italic">✦</span>
        </span>
      ))}
    </span>
  );
  return (
    <div data-testid="editorial-marquee" className="border-y-2 border-gold/60 py-5 overflow-hidden bg-ivory" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
